//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('ediImports', {
//        templateUrl: 'views/components/views/ediImports/ediImports.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'ttGridFactory', function (stateService, ttGridFactory) {
//            const vm = this;
            
//            vm.grid = new ttGridFactory({
//                rememberId: 'w_ediimportsComponentGrid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            })
//                .setToolbar({ wrapping: true })
//                .setLoadDataFunction({
//                    method: 3352,
//                    parameters: {}
//                })
//                .setCustomToolbarButtons([{
//                    name: 'ediimports_new',
//                    text: 'ediimports_new',
//                    func: () => stateService.go('ediimport', { edi_import_keyno: '0' }),
//                    icon: 'fa-plus',
//                    cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
//                    translate: true
//                }]);
//        }]
//    });
//})();
